import { render } from "./MvButton.vue?vue&type=template&id=88ba4a80&ts=true"
import script from "./MvButton.vue?vue&type=script&lang=ts"
export * from "./MvButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__